var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11292_16997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 0.416016H3.33366C1.72283 0.416016 0.416992 1.72185 0.416992 3.33268V16.666C0.416992 18.2768 1.72283 19.5827 3.33366 19.5827H16.667C18.2778 19.5827 19.5837 18.2768 19.5837 16.666V3.33268C19.5837 1.72185 18.2778 0.416016 16.667 0.416016Z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0.833333C2.67029 0.833333 2.03441 1.09673 1.56557 1.56557C1.09673 2.03441 0.833333 2.67029 0.833333 3.33333V16.6667C0.833333 17.3297 1.09673 17.9656 1.56557 18.4344C2.03441 18.9033 2.67029 19.1667 3.33333 19.1667H16.6667C17.3297 19.1667 17.9656 18.9033 18.4344 18.4344C18.9033 17.9656 19.1667 17.3297 19.1667 16.6667V3.33333C19.1667 2.67029 18.9033 2.03441 18.4344 1.56557C17.9656 1.09673 17.3297 0.833333 16.6667 0.833333H3.33333ZM0.976311 0.976311C1.60143 0.351189 2.44928 0 3.33333 0H16.6667C17.5507 0 18.3986 0.351189 19.0237 0.976311C19.6488 1.60143 20 2.44928 20 3.33333V16.6667C20 17.5507 19.6488 18.3986 19.0237 19.0237C18.3986 19.6488 17.5507 20 16.6667 20H3.33333C2.44928 20 1.60143 19.6488 0.976311 19.0237C0.351189 18.3986 0 17.5507 0 16.6667V3.33333C0 2.44928 0.351189 1.60143 0.976311 0.976311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z",
    fill: "url(#paint0_linear_11292_16997)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11292_16997",
    x1: 5,
    y1: 10,
    x2: 15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11292_16997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexus);
export default __webpack_public_path__ + "static/media/nexus.7694b61faf94bec61ce34873907b0fb6.svg";
export { ForwardRef as ReactComponent };